export enum MapTypesEnum {
  GPSmap,
  RetailMatchMap,
}
